import { ROUTES, SETTINGS_ROUTES } from "@/shared/constants/routes";

import { useIsAdmin } from "@/shared/hooks/use-is-admin";
import { Navigate, RouteObject } from "react-router-dom";
import SettingsLayout from "../components/layout";
import SettingsMainPage from "../components/main";
import ControlSetEditPage from "../components/control-set-edit";
import ControlSetsList from "../components/control-sets-list";
import QuestionnairesList from "../components/questionnaires-list";
import IntakeFormScreen from "../components/intake-form-screen";
import ContinuousMonitoring from "../components/continuous-monitoring";
import GoogleDriveIntegrationPage from "../components/integrations/google-drive-integration-page";
import JiraIntegrationPage from "../components/integrations/jira-integration-page";

import WhitelistedDomainsList from "../components/whitelisted-domains";
import TierMappingPage from "../components/tier-mapping";

const AdminOnlyTierMappingRoute = () => {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <Navigate to={`/${ROUTES.SETTINGS}`} state={{ tab: "general" }} replace />;
  }

  return <TierMappingPage />;
};

const AdminOnlyWhitelistedDomainsRoute = () => {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <Navigate to={`/${ROUTES.SETTINGS}`} state={{ tab: "general" }} replace />;
  }

  return <WhitelistedDomainsList />;
};


export const SettingsRoutes: RouteObject[] = [
  {
    path: ROUTES.SETTINGS,
    Component: SettingsLayout,
    children: [
      {
        index: true,
        Component: SettingsMainPage
      },
      {
        path: SETTINGS_ROUTES.INTEGRATIONS,
        element: <Navigate to={`/${ROUTES.SETTINGS}?tab=integrations`} replace />,
      },
      {
        path: SETTINGS_ROUTES.INTEGRATIONS_JIRA,
        Component: JiraIntegrationPage,
      },
      {
        path: SETTINGS_ROUTES.INTEGRATIONS_GOOGLE_DRIVE,
        Component: GoogleDriveIntegrationPage,
      },
      {
        path: SETTINGS_ROUTES.THIRD_PARTY_CONTROL_SETS,
        Component: ControlSetsList,
      },
      {
        path: SETTINGS_ROUTES.THIRD_PARTY_QUESTIONNAIRES,
        Component: QuestionnairesList,
      },
      {
        path: SETTINGS_ROUTES.INTAKE_FORM,
        Component: IntakeFormScreen,
      },
      {
        path: SETTINGS_ROUTES.CONTINUOUS_MONITORING,
        Component: ContinuousMonitoring,
      },
      {
        path: SETTINGS_ROUTES.TIER_MAPPING,
        Component: AdminOnlyTierMappingRoute,
      },
      {
        path: SETTINGS_ROUTES.WHITELISTED_DOMAINS,
        Component: AdminOnlyWhitelistedDomainsRoute,
      },
    ],
  },
  // Standalone route for control set editing (full screen, no settings layout)
  {
    path: `${ROUTES.SETTINGS}/control-sets/edit`,
    Component: ControlSetEditPage,
  },
];
